import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api/client';

export default function ChangePasswordPage({ isForced, onComplete }) {
  const { user } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword.length < 4) {
      setError('새 비밀번호는 4자리 이상이어야 합니다.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('새 비밀번호와 확인이 일치하지 않습니다.');
      return;
    }

    setLoading(true);
    try {
      const body = { new_password: newPassword };
      if (!isForced) body.current_password = currentPassword;
      await api.post('/auth/change-password', body);
      if (onComplete) onComplete();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (isForced) {
    return (
      <div style={{ display: 'flex', minHeight: '100vh', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' }}>
        <div style={{ background: '#fff', borderRadius: 16, padding: '40px 36px', width: 420, boxShadow: '0 8px 32px rgba(0,0,0,0.1)' }}>
          <div style={{ textAlign: 'center', fontSize: 22, fontWeight: 800, marginBottom: 6 }}>
            <span style={{ color: '#3b82f6' }}>SOOSAN</span> ERP
          </div>
          <div style={{ textAlign: 'center', color: '#64748b', fontSize: 14, marginBottom: 8 }}>비밀번호 변경</div>
          <div className="alert alert-warning" style={{ marginBottom: 20 }}>
            ⚠ 최초 로그인입니다. 보안을 위해 비밀번호를 변경해 주세요.
          </div>
          <div style={{ textAlign: 'center', marginBottom: 20, fontSize: 13, color: '#475569' }}>
            <strong>{user?.name}</strong> ({user?.email})
          </div>
          {error && <div className="alert alert-danger" style={{ marginBottom: 12 }}>{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">새 비밀번호</label>
              <input className="form-input" type="password" value={newPassword}
                onChange={e => setNewPassword(e.target.value)} placeholder="4자리 이상" />
            </div>
            <div className="form-group">
              <label className="form-label">새 비밀번호 확인</label>
              <input className="form-input" type="password" value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)} placeholder="한번 더 입력" />
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading}
              style={{ width: '100%', padding: 12, fontSize: 15, borderRadius: 10, opacity: loading ? 0.7 : 1 }}>
              {loading ? '변경 중...' : '비밀번호 변경'}
            </button>
          </form>
        </div>
      </div>
    );
  }

  // 일반 비밀번호 변경 모달
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 14, padding: 28, width: 420 }}>
        <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 16, paddingBottom: 10, borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between' }}>
          <span>비밀번호 변경</span>
          <span style={{ cursor: 'pointer', color: '#94a3b8' }} onClick={onComplete}>✕</span>
        </div>
        {error && <div className="alert alert-danger" style={{ marginBottom: 12 }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">현재 비밀번호</label>
            <input className="form-input" type="password" value={currentPassword}
              onChange={e => setCurrentPassword(e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">새 비밀번호</label>
            <input className="form-input" type="password" value={newPassword}
              onChange={e => setNewPassword(e.target.value)} placeholder="4자리 이상" />
          </div>
          <div className="form-group">
            <label className="form-label">새 비밀번호 확인</label>
            <input className="form-input" type="password" value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)} />
          </div>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button type="button" className="btn btn-outline" onClick={onComplete}>취소</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? '변경 중...' : '변경'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
